import { createContext } from 'react';

/**
 * Provides the id of the Custom Homepage a subtree is rendered within, merged
 * into the analytics traits of the events raised there as `homepage_id`.
 *
 * Deliberately a context rather than store state: it dies at the subtree
 * boundary, so a screen outside the homepage cannot inherit an id it has no
 * claim to. Screens that carry a homepage id in their own URL (the per-module
 * "see all" feed) set the trait from the route instead.
 */
export const CustomHomepageIdContext = createContext<string | undefined>(
  undefined
);
